import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const availableUnits = [
  { max: 2760000, value: 60000, unit: 'minute' }, // max 46 minutes
  { max: 72000000, value: 3600000, unit: 'hour' }, // max 20 hours
  { max: 518400000, value: 86400000, unit: 'day' }, // max 6 days
  { max: 2419200000, value: 604800000, unit: 'week' }, // max 28 days
  { max: 28512000000, value: 2592000000, unit: 'month' }, // max 11 months
  { max: Infinity, value: 31536000000, unit: 'year' }
];

@Pipe({ name: 'relativeTime' })
export class RelativeTimePipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(
    date: Date | string,
    style: Intl.RelativeTimeFormatStyle = 'long',
    numeric: Intl.RelativeTimeFormatNumeric = 'auto'
  ): string {
    const now = Date.now();
    const then = new Date(date);

    if (isNaN(then.getMilliseconds())) {
      return 'unknown';
    }

    const diff = then.getTime() - now;
    const { unit, value } = availableUnits.find((unit) => Math.abs(diff) < unit.max) as any;

    return this.relativeTime(Math.round(diff / value), this.translateService.currentLang, unit, {
      numeric,
      style
    });
  }

  private relativeTime(
    value: number,
    lang: string,
    unit: Intl.RelativeTimeFormatUnit,
    options?: Intl.RelativeTimeFormatOptions
  ) {
    return new Intl.RelativeTimeFormat(lang, options).format(value, unit);
  }
}
